<template>
  <!-- 出差申请 -->
  <div class="detail">
    <ax-panel title="出差取消信息">
      <van-cell title="申请人">
        <a class="link_a" :href="'tel:' + data.header.emplid_phone">{{
          data.header.emplid_description
        }}</a>
      </van-cell>
      <van-cell title="取消天数">
        <router-link
          class="link_a"
          :to="{
            name: 'approvalDetailList',
            query: $route.query
          }"
          >{{ data.header.qh_total_days }}天</router-link
        >
      </van-cell>
      <van-cell title="开始日期" :value="data.header.bgn_dt"></van-cell>
      <van-cell title="结束日期" :value="data.header.end_dt"></van-cell>
      <van-cell title="申请说明" :value="data.header.comments"></van-cell>
    </ax-panel>
  </div>
</template>

<script>
export default {
  props: ["data"]
};
</script>

<style></style>
